import type { JustificativaConflitosDialogProps } from "./types-justificativa-conflitos-dialog";
import { useJustificativaConflitosDialog } from "./use-justificativa-conflitos-dialog";
import { JustificativaConflitosDialogView } from "./view-justificativa-conflitos-dialog";

/** Justificativa dos conflitos novos que um "Aplicar na simulação" cria (RN011, HU 2224). */
export function JustificativaConflitosDialog(props: JustificativaConflitosDialogProps) {
  const vm = useJustificativaConflitosDialog(props);

  return <JustificativaConflitosDialogView {...vm} />;
}

export type * from "./types-justificativa-conflitos-dialog";
